module.exports = __webpack_public_path__ + "img/gj_10.28449a12.jpg";